import React, { useContext } from 'react';
import { MapContainer, ZoomControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'assets/scss/leaflet-custom.scss';
import { FloorSelectorControl } from './FloorSelectorControl';
import LayersController from './LayersController';
import { TileLayer } from 'react-leaflet';
import config from '../config';
import { MapContainerRefContext } from '../utils/mapContainerRef.context';
import useDevice from 'hooks/useDevice';
import L from 'leaflet';
import { observer } from 'mobx-react';
import { useMapStore } from 'contexts/RootStore.context';
import LoadingScreen from 'components/Loading/LoadingScreen';
import KeyLegend from './KeyLegend';
import { StyledMapWrapper } from '../Styled';

export const MapContainerWrapper = observer(() => {

  const { loading, selectedBuildingId, levels } = useMapStore()
  const { setMapContainerRef } = useContext(MapContainerRefContext);
  const { isMobileDevice } = useDevice();

  const bounds = levels ? L.geoJSON(levels).getBounds() : undefined; // set bounds of map to levelFeature bounds.

  if (loading || !levels)
    return <LoadingScreen />

  return (
    <StyledMapWrapper>
      <MapContainer
        bounds={bounds}
        maxZoom={config.maxZoom}
        minZoom={config.minZoom}
        zoom={config.zoom}
        scrollWheelZoom={false}
        zoomControl={false}
        ref={setMapContainerRef} // set map ref to usestate in parent to be passed to external components.
      >
        {selectedBuildingId !== "" && <FloorSelectorControl />}
        {!isMobileDevice && <ZoomControl position="topright" />}
        <LayersController />
        <KeyLegend />
        <TileLayer
          updateWhenZooming
          opacity={0.5}
          zIndex={-1}
          maxNativeZoom={19} // upscale OSM tiles, because they dont give lvl 20.
          maxZoom={config.maxZoom}
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </MapContainer>
    </StyledMapWrapper>
  );
})
